import { FleetDefinition } from './../models/FleetDefinition';

export class GetFleetDefinitionDefaultsResponse {
    fleetDefinitionDefaults?: FleetDefinition;
}